module.exports = __webpack_public_path__ + "img/setsemg.6e0d0ab4.png";